import { type SearchParamsValue } from 'hb-react/shared/hooks/useParsedQueryParams/types';

// Parser functions for different data types
export const PARSERS = {
  boolean: (value: SearchParamsValue): boolean | undefined => {
    if (value === 'true') {
      return true;
    }
    if (value === 'false') {
      return false;
    }

    return undefined;
  },
  number: (value: SearchParamsValue): number | undefined => {
    if (!value) {
      return undefined;
    }

    const parsed = Number(value);

    return Number.isNaN(parsed) ? undefined : parsed;
  },
  string: (value: SearchParamsValue): string | undefined => value || undefined,
  numberArray: (value: SearchParamsValue): Array<number> | undefined => {
    if (!value) {
      return undefined;
    }

    const parsed = value
      .split(',')
      .map(Number)
      .filter((num) => !Number.isNaN(num));

    return parsed.length > 0 ? parsed : undefined;
  },
  stringArray: (value: SearchParamsValue): Array<string> | undefined => {
    if (!value) {
      return undefined;
    }

    return value.split(',');
  },
} as const;
